import LinkLookup from 'components/LinkLookup';
import LoadingIndicator from 'components/LoadingIndicator';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import pluralize from 'pluralize';
import React from 'react';
import { getNavParamsByResource } from 'selectors/nav';
import {
  getNotifications,
  getNotificationsCount,
  getNotificationsLoading,
} from 'selectors/notifications';
import { useSelector } from 'store';

const NotificationsHeader: React.FC = () => {
  const navParams = useSelector(getNavParamsByResource(resourceQueryParamName.notifications));

  const offset = parseInt(navParams.offset as string, 10);
  const notifications = useSelector(getNotifications);
  const totalCount = useSelector(getNotificationsCount);
  const loading = useSelector(getNotificationsLoading);

  return (
    <header className="w-full px-6">
      <div className="flex flex-col gap-6">
        <div className="flex flex-row justify-between items-center">
          <div className="flex items-center gap-2">
            <div
              role="button"
              tabIndex={0}
              className="border-b-4 border-litlingo-orange text-menu-item cursor-pointer pb-1 px-2"
            >
              Notifications
            </div>
            <LinkLookup
              routeName="comments"
              className="border-b-4 border-transparent text-menu-item cursor-pointer pb-1 px-2"
            >
              My Comments
            </LinkLookup>
          </div>
        </div>
        <div className="flex flex-nowrap justify-between h-8">
          <div className="flex flex-row items-end">
            <h2 className="text-heading-2">Notifications</h2>
          </div>

          <div className="self-end">
            {loading ? (
              <LoadingIndicator className="ml-2" size="5" />
            ) : (
              <>
                <span className="font-bold">
                  {` ${notifications.length === 0 ? 0 : offset + 1}-${
                    offset + notifications.length
                  }`}
                </span>
                {` of ${
                  totalCount === 10000 ? '+10,000' : pluralize('Notification', totalCount, true)
                }`}
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default NotificationsHeader;
